import { Component, OnInit } from '@angular/core';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-calculate-roi-page',
  templateUrl: './calculate-roi-page.component.html',
  styleUrls: ['./calculate-roi-page.component.scss']
})
export class CalculateRoiPageComponent implements OnInit {

  constructor(private ecoDocsTitleService: EcoDocsTitleService) { }

  ngOnInit(): void {
    this.ecoDocsTitleService.setTitle('Calculate ROI from Digital Transformation & Workflow Automation', false);
  }

}
